/**
 * mobile-menu-2level.js
 * 2-Ebenen-Slide-Logik für das Mobile-Drawer-Menü.
 * Dockt am bestehenden drawer-menu__panel an — ersetzt nur
 * die Slide-Tiefe für die custom .mm2__* Elemente.
 * theme.min.js bleibt unberührt.
 */

(function () {
  'use strict';

  var OPEN_CLASS  = 'mm2__panel--open';
  var SLIDE_CLASS = 'mm2--sliding';

  /**
   * Setzt die Höhe des Containers so, dass absolute Panels
   * den vollen Inhalt überdecken können.
   */
  function syncHeight(container, panel) {
    // Temporär panel sichtbar machen um scrollHeight zu messen
    var prevVisibility = panel.style.visibility;
    var prevDisplay    = panel.style.display;
    panel.style.visibility = 'hidden';
    panel.style.transform  = 'none';
    panel.style.transition = 'none';
    panel.style.display    = 'block';

    var panelH = panel.scrollHeight;

    // Rücksetzen
    panel.style.visibility = prevVisibility;
    panel.style.transform  = '';
    panel.style.transition = '';
    panel.style.display    = '';

    // l1-list Höhe
    var l1List = container.querySelector('[data-mm2-l1-list]');
    var l1H    = l1List ? l1List.scrollHeight : 0;

    var minH = Math.max(panelH, l1H, 200);
    container.style.minHeight = minH + 'px';
  }

  function resetHeight(container) {
    container.style.minHeight = '';
  }

  /**
   * Initialisiert ein einzelnes Menü-Container-Element.
   */
  function initContainer(container) {
    if (container._mm2Init) return;
    container._mm2Init = true;

    var triggers    = container.querySelectorAll('[data-mm2-trigger]');
    var backButtons = container.querySelectorAll('[data-mm2-back]');
    var allPanels   = container.querySelectorAll('[data-mm2-panel]');

    if (triggers.length === 0) return;

    // --- Trigger: Ebene 1 → Ebene 2 ---
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panelId = trigger.getAttribute('data-mm2-trigger');
        var panel   = container.querySelector('#' + panelId);
        if (!panel) return;

        // Höhe vor dem Öffnen synchronisieren
        syncHeight(container, panel);

        // Ebene-1-Liste ausblenden (slide-out)
        var l1List = container.querySelector('[data-mm2-l1-list]');
        if (l1List) {
          l1List.classList.add(SLIDE_CLASS);
          l1List.setAttribute('aria-hidden', 'true');
        }

        // Panel einblenden
        panel.classList.add(OPEN_CLASS);
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');

        // Fokus auf ersten interaktiven Inhalt des Panels
        requestAnimationFrame(function () {
          var firstFocusable = panel.querySelector('button, a, [tabindex]');
          if (firstFocusable) firstFocusable.focus();
          // Scroll des Panels an den Anfang
          panel.scrollTop = 0;
        });
      });
    });

    // --- Back-Buttons: Ebene 2 → Ebene 1 ---
    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-mm2-panel]');
        if (!panel) return;

        panel.classList.remove(OPEN_CLASS);
        panel.setAttribute('aria-hidden', 'true');

        var panelId = panel.id;
        var trigger = container.querySelector('[data-mm2-trigger="' + panelId + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');

        var l1List = container.querySelector('[data-mm2-l1-list]');
        if (l1List) {
          l1List.classList.remove(SLIDE_CLASS);
          l1List.setAttribute('aria-hidden', 'false');
        }

        // Fokus zurück auf Trigger, Höhe zurücksetzen
        requestAnimationFrame(function () {
          resetHeight(container);
          if (trigger) trigger.focus();
        });
      });
    });

    // --- Drawer schliessen: alle Panels zurücksetzen ---
    function resetAll() {
      allPanels.forEach(function (p) {
        p.classList.remove(OPEN_CLASS);
        p.setAttribute('aria-hidden', 'true');
      });
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      var l1List = container.querySelector('[data-mm2-l1-list]');
      if (l1List) {
        l1List.classList.remove(SLIDE_CLASS);
        l1List.setAttribute('aria-hidden', 'false');
      }
      resetHeight(container);
    }

    // Overlay-Klick
    var drawerRoot  = container.closest('[data-drawer-menu]');
    var overlay     = drawerRoot ? drawerRoot.querySelector('[data-overlay]') : null;
    if (overlay) overlay.addEventListener('click', resetAll);

    // Theme-eigene Events
    if (drawerRoot) drawerRoot.addEventListener('drawerClose', resetAll);
    document.addEventListener('drawerClose', resetAll);

    // Fallback: Theme setzt data-in-initial-position zurück wenn Drawer schliesst
    var allLinksEl  = container.closest('[data-all-links]') || container;
    var observer    = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'data-in-initial-position') {
          if (allLinksEl.getAttribute('data-in-initial-position') === 'true') {
            resetAll();
          }
        }
      });
    });
    observer.observe(allLinksEl, { attributes: true });
  }

  // --- Bootstrap ---
  function boot() {
    document.querySelectorAll('[data-mm2-container]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // --- Theme-Editor-Support ---
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mm2-container]').forEach(function (c) {
      c._mm2Init = false;
      initContainer(c);
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    document.querySelectorAll('[data-mm2-container]').forEach(function (c) {
      c.querySelectorAll('[data-mm2-panel]').forEach(function (p) {
        p.classList.remove(OPEN_CLASS);
        p.setAttribute('aria-hidden', 'true');
      });
      var l1 = c.querySelector('[data-mm2-l1-list]');
      if (l1) {
        l1.classList.remove(SLIDE_CLASS);
        l1.setAttribute('aria-hidden', 'false');
      }
      resetHeight(c);
    });
  });

})();
